const setOneYearAgo = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 1);
  today.setHours(0, 0, 0, 0);

  return Math.ceil(today.getTime() / 1000);
};

export default setOneYearAgo;
